import stakeholderFilesService from "../../services/stakeholderFilesService";

const state = {
  stakeholderFiles: []
};

const getters = {
  stakeholderFiles: state => {
    return state.stakeholderFiles;
  }
};

const actions = {
  getStakeholderFiles({ commit }) {
    stakeholderFilesService.fetchStakeholdersFiles().then(stakeholderFiles => {
      commit("SET_STAKEHOLDER_FILES", stakeholderFiles.data);
    });
  },
  deleteStakeholderFile({ commit }, pk) {
    stakeholderFilesService.deleteStakeholderFile(pk);
    commit("DELETE_STAKEHOLDER_FILE", pk)
  },
  addStakeholderFile({ commit }, stakeholderFile) {
    commit("ADD_STAKEHOLDER_FILE", stakeholderFile)
  }
};

const mutations = {
  SET_STAKEHOLDER_FILES(state, response) {
    state.stakeholderFiles = response;
  },
  DELETE_STAKEHOLDER_FILE(state, pk) {
    state.stakeholderFiles = state.stakeholderFiles.filter(obj => obj.pk !== pk);
  },
  ADD_STAKEHOLDER_FILE(state, stakeholderFile) {
    state.stakeholderFiles.push(stakeholderFile);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
